import { render } from "./BatchModal.vue?vue&type=template&id=1ac98b54&scoped=true"
import script from "./BatchModal.vue?vue&type=script&lang=js"
export * from "./BatchModal.vue?vue&type=script&lang=js"

import "./BatchModal.vue?vue&type=style&index=0&id=1ac98b54&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac98b54"]])

export default __exports__